import sendData from "./sendData";
import notifier from "./notifier";

function getMessage(content_type, status) {
    const messages = {
        'comments.comment': {
            460: gettext('Вы не можете голосовать за этот комментарий, так как являетесь его автором.'),
            461: gettext('Вы уже голосовали за этот комментарий.'),
        },
        'shop.shopoffers': {
            460: gettext('Вы не можете голосовать за эту аранжировку, так как являетесь её автором.'),
            461: gettext('Вы уже голосовали за эту аранжировку.'),
        },
        'education.educationproduct': {
            460: gettext('Вы не можете голосовать за этот материал, так как являетесь его автором.'),
            461: gettext('Вы уже голосовали за этот материал.'),
        },
        'articles.article': {
            460: gettext('Вы не можете голосовать за эту статью, так как являетесь её автором.'),
            461: gettext('Вы уже голосовали за эту статью.'),
        }
    };
    return messages[content_type][status]
}

function saveRating() {
    document.querySelectorAll('.vote-form__button').forEach(function (button) {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            const ratingForm = button.parentElement;
            let value = button.getAttribute('data-value');
            // записываем значение в поле формы
            ratingForm['score'].value = value;
            // начальное значение рейтинга
            let initialScore = parseInt(button.textContent || button.innerText);
            // обновляем значение рейтинга, в случае ошибки вернем его обратно
            button.innerHTML = initialScore + parseInt(ratingForm['score'].value);

            // если голосуем за комменты
            if (ratingForm['content_type'].value == 'comments.comment'){
                if (value > 0){
                    button.classList.remove('vote-form__button_type_comment_style_zero_positive');
                    button.classList.add('vote-form__button_type_comment_style_positive');
                } else {
                    button.classList.remove('vote-form__button_type_comment_style_zero_negative');
                    button.classList.add('vote-form__button_type_comment_style_negative');
                }
            }

            sendData('POST', ratingForm.getAttribute('action'), new FormData(ratingForm))
            .then((data) => {
              if (data){
                if (data.key){
                    notifier.success(gettext('Ваша оценка принята'));
                } else if (data.status == 460 || data.status == 461) {
                    notifier.alert(getMessage(ratingForm['content_type'].value, data.status));
                    button.innerHTML = initialScore;
                } else {
                    notifier.alert(gettext('Ваш голос не принят. Обновите страницу и попробуйте еще раз.'));
                    button.innerHTML = initialScore;
                }
              }
            });
            return false;
        });
    });
};

export default saveRating;
